'use strict';

module.exports = ['$scope', '$timeout', 'PlantSvc', function ($scope, $timeout, PlantSvc) {
    // ------------------
    // scope functions
    // ------------------
    $scope.addSubscriber = function () {
        validate();
        // do submit
        if ($scope.subscribers_form.$valid) {

            // add field to the list
            var subscriber = {
                name: $scope.subscriber.name_input,
                email: $scope.subscriber.email_input,
                isNew: true
            };

            // save on the server
            PlantSvc.addSubscriber($scope.plant, subscriber).success(function (data) {

                $scope.subscribers.push(data);

                $timeout(function () {
                    subscriber.isNew = false;
                }, 2000);

                // reset the form values
                $scope.subscriber.name_input = '';
                $scope.subscriber.email_input = '';
                $scope.subscribers_form.submitted = false;
            });
        } else {
            $scope.subscribers_form.submitted = true;
        }
    };

    $scope.removeSubscriber = function (subscriber) {
        PlantSvc.deleteSubscriber($scope.plant, subscriber.id).then(function (data) {
            loadSubscribers();
        });
    };

    // ------------------
    // Watches
    // ------------------
    $scope.$watch('subscriber', function () {
        validate();
    }, true);

    // ------------------
    // Helper functions
    // ------------------
    function validate() {
        var emails = $.map($scope.subscribers, function (val, i) {
            return val.email;
        });

        if ($.inArray($scope.subscriber.email_input, emails) === -1) {
            $scope.subscribers_form.email_input.$setValidity("unique", true);
        }
        else {
            $scope.subscribers_form.email_input.$setValidity("unique", false);
        }
    }

    function loadSubscribers() {
        PlantSvc.getSubscribers($scope.plant).success(function (data) {
            $scope.subscribers = data;
        });
    }

    // ------------------
    // Fetch Data
    // ------------------
    loadSubscribers();

    // ------------------
    // Initialization
    // ------------------
    $scope.subscribers = [];

    $scope.subscriber = {name_input: "", email_input: ""};
}];